import { render, staticRenderFns } from "./bullSemenDisposal.vue?vue&type=template&id=7521a478&scoped=true&"
import script from "./bullSemenDisposal.vue?vue&type=script&lang=js&"
export * from "./bullSemenDisposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7521a478",
  null
  
)

export default component.exports